import Logo from '~/assets/asset-company-logo.svg?react';
import CircleSpinner from '~/components/data-display/CircleSpinner/CircleSpinner';
import useDataTestId from '~/hooks/useDataTestId';
import styles from './LoadingScreen.module.scss';

export default function LoadingScreen({ dataTestId }: { dataTestId?: string }) {
  const dt = useDataTestId(dataTestId);
  return (
    <div className={styles.root} data-testid={dt('loadingScreen')}>
      <CircleSpinner size="huge" className={styles.progress} />
      <Logo className={styles.logo} />
    </div>
  );
}
